import React from 'react';
import Path from '@leverege/path';
import { isReactComponent } from '../../Util.js';
export function getItemKey(item, index, dGet) {
  if (typeof dGet === 'function') {
    return dGet(item, index);
  }
  if (typeof dGet === 'string') {
    return Path.get(dGet, item, index);
  }
  return item?.id ? item.id : index;
}
export function renderDynamicComponent(Comp, props) {
  return isReactComponent(Comp) ? /*#__PURE__*/React.createElement(Comp, props) : Comp(props);
}